import { Controller } from "@hotwired/stimulus"
import { turboFetchForm } from "../util/common"

export default class extends Controller {
  static targets = ["blur", "change"]
  static values = { previewUrl: String }

  connect() {
    this.updatePreview = this.updatePreview.bind(this)

    this.blurTargets.forEach((target) => {
      target.addEventListener("blur", this.updatePreview)
    })
    this.changeTargets.forEach((target) => {
      target.addEventListener("change", this.updatePreview)
    })
    this.element.addEventListener("tags-input:added", this.updatePreview)
    this.element.addEventListener("tags-input:deleted", this.updatePreview)
  }

  disconnect() {
    this.blurTargets.forEach((target) => {
      target.removeEventListener("blur", this.updatePreview)
    })
    this.changeTargets.forEach((target) => {
      target.removeEventListener("change", this.updatePreview)
    })
    this.element.removeEventListener("tags-input:added", this.updatePreview)
    this.element.removeEventListener("tags-input:deleted", this.updatePreview)
  }

  updatePreview() {
    turboFetchForm(this.previewUrlValue, this.element)
  }
}
